module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('h1', [_vm._v("Product Information")]), _vm._v(" "), _c('p', [_vm._v("Fill up all necessary information")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "proposeitem",
      "method": "post",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addProduct($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "token",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "product_name"
    }
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "product_name",
      "id": "product_name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Price (Php)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "price",
      "id": "price"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stock"
    }
  }, [_vm._v("No. of Available Stock")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "stock",
      "id": "stock"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "color",
      "id": "color"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "category",
      "id": "category"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("select category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "light"
    }
  }, [_vm._v("light")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dark"
    }
  }, [_vm._v("dark")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "led"
    }
  }, [_vm._v("Led Capable")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "led",
      "id": "led"
    }
  }, [_c('option', {
    attrs: {
      "value": "YES",
      "selected": ""
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO"
    }
  }, [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "material"
    }
  }, [_vm._v("Material")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "material",
      "id": "material"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select Material")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "wood"
    }
  }, [_vm._v("wood")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "glass"
    }
  }, [_vm._v("glass")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "concrete"
    }
  }, [_vm._v("concrete")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "image"
    }
  }, [_vm._v("Product Image")]), _vm._v(" "), _c('input', {
    staticStyle: {},
    attrs: {
      "type": "file",
      "name": "image",
      "id": "image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding": "0px 15px",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "button-type-e",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Upload Product")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac12b93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminProducts.vue
// module id = 147
// module chunks = 0